module.exports = "/images/milano-7.jpg";